import {common} from '../index';
import state from './index';

export const nav_Index_List = (state) =>{
  if(state.nav_list.length>1) {
   return state.nav_list.slice(0,8);
  }
}
export const veniceStartMoney = (state) =>{
  let num = state.veniceStartMoney.toFixed(2)
  return num
}
export const pro3StarMoney = (state) =>{
  let num = state.pro3StarMoney.toFixed(2)
  return num
}


// WEBPACK FOOTER //
// ./src/common/store/getters.js